"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Supportive functions
 */
var type2Write = function type2Write(type) {
  switch (type) {
    case 'u8':
      return 'writeUInt8';

    case 'u16':
      return 'writeUInt16LE';

    case 'u32':
      return 'writeUInt32LE';

    case 'u64':
      return 'writeBigUInt64LE';

    default:
      throw new Error('Invalid type');
  }
};

var type2Read = function type2Read(type) {
  switch (type) {
    case 'u8':
      return 'readUInt8';

    case 'u16':
      return 'readUInt16LE';

    case 'u32':
      return 'readUInt32LE';

    case 'u64':
      return 'readBigUInt64LE';

    default:
      throw new Error('Invalid type');
  }
};
/**
 * Unsigned integer
 */


var usize = function usize(value, type, byteLength) {
  var _this = this;

  _classCallCheck(this, usize);

  _defineProperty(this, "toBuffer", function () {
    var buf = Buffer.allocUnsafe(_this.space);
    buf[type2Write(_this.type)](_this.value);
    return buf;
  });

  _defineProperty(this, "fromBuffer", function (buf) {
    if (!Buffer.isBuffer(buf)) throw new Error('Invalid buffer');
    _this.value = buf[type2Read(_this.type)]();
    return _this.value;
  });

  this.value = value;
  this.type = type;
  this.space = byteLength;
};

var u8 = /*#__PURE__*/function (_usize) {
  _inherits(u8, _usize);

  var _super = _createSuper(u8);

  function u8() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    _classCallCheck(this, u8);

    return _super.call(this, value, 'u8', 1);
  }

  return u8;
}(usize);

var u16 = /*#__PURE__*/function (_usize2) {
  _inherits(u16, _usize2);

  var _super2 = _createSuper(u16);

  function u16() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    _classCallCheck(this, u16);

    return _super2.call(this, value, 'u16', 2);
  }

  return u16;
}(usize);

var u32 = /*#__PURE__*/function (_usize3) {
  _inherits(u32, _usize3);

  var _super3 = _createSuper(u32);

  function u32() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    _classCallCheck(this, u32);

    return _super3.call(this, value, 'u32', 4);
  }

  return u32;
}(usize);

var u64 = /*#__PURE__*/function (_usize4) {
  _inherits(u64, _usize4);

  var _super4 = _createSuper(u64);

  function u64() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    _classCallCheck(this, u64);

    return _super4.call(this, value, 'u64', 8);
  }

  return u64;
}(usize);

module.exports = {
  u8: u8,
  u16: u16,
  u32: u32,
  u64: u64
};